import { atom } from "recoil";



const compareListState = atom({
    key: 'compareListState',
    default: [] as any
});

const stackRankState = atom({
    key: 'stackRankState',
    default: { State: [], Districts: [], Subdistricts: [], Pincode: [], Villages: [], Branches: [], Partners: [], 'Relationship Managers': [] } as any
})

const compareListLengthState = atom({
    key: 'compareListLength',
    default: {
        districtListLength: 0,
        subDistrictListLength: 0,
        pincodesListLength: 0,
        villagessListLength: 0,
    }
});

const selectedChildState = atom<Record<number, number>>({
    key: 'selectedChild',
    default: { 4: 0, 5: 0, 6: 0, 7: 0 }
});

const pageNumberState = atom<number>({
    key: 'pageNumber',
    default: 1
})

const compareTableSortState = atom<{ sorting: boolean; buttonState: [number, boolean] }>({
    key: 'compareTableSortState',
    default: { sorting: false, buttonState: [2, false] }
});

export { compareListState, stackRankState, compareListLengthState, selectedChildState, pageNumberState, compareTableSortState };

